import { createSelector } from 'reselect';

import { BuildingState, Building } from 'store/building/types';

import { RootState } from '../reducer';

export const buildingStateSelector = (state: RootState): BuildingState => state.building;

export const selectBuilding = createSelector(buildingStateSelector, (buildingState) => buildingState.building);

export const selectBuildingStatus = createSelector(
  buildingStateSelector,
  (buildingState) => buildingState.getBuilding.status,
);

export const selectBuildingTimeZone = createSelector(
  selectBuilding,
  (building: Building | null): string | null => building?.timezone ?? null,
);

export const selectBuildingLocale = createSelector(
  selectBuilding,
  (building: Building | null): string | null => building?.locale ?? null,
);
